/* Afkar Plus - Black Friday helpers (BeyondADS, Oct 2026)
   1. Countdowns: every [data-bf-end="2026-11-30T23:59:00+02:00"] fills its [data-bf-d|h|m|s] once a second.
      After the end time the clock hides itself (and [data-bf-ended] inside it shows, if present).
   2. Copy code: [data-bf-copy="CODE"] copies the code and flashes "Copied". */
(function () {
  'use strict';
  if (window.__afkarBF) return; window.__afkarBF = true;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function set(root, sel, v) { root.querySelectorAll(sel).forEach(function (el) { if (el.textContent !== v) el.textContent = v; }); }
  function tick() {
    document.querySelectorAll('[data-bf-end]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-bf-end'));
      if (isNaN(end)) { el.hidden = true; return; }
      var ms = end - Date.now();
      if (ms <= 0) {
        var ended = el.querySelector('[data-bf-ended]');
        if (ended) { ended.hidden = false; el.classList.add('is-ended'); } else el.hidden = true;
        return;
      }
      var s = Math.floor(ms / 1000);
      set(el, '[data-bf-d]', pad(Math.floor(s / 86400)));
      set(el, '[data-bf-h]', pad(Math.floor(s % 86400 / 3600)));
      set(el, '[data-bf-m]', pad(Math.floor(s % 3600 / 60)));
      set(el, '[data-bf-s]', pad(s % 60));
      el.classList.add('is-on');
    });
  }
  /* product page: the Black Friday block goes right under the price, then follows the bag live */
  function money(c) { var v = (c / 100); return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  var bfx = null, ids = null, cartBusy = false;
  function pdpNote() {
    var tpl = document.getElementById('bf-pdp-tpl');
    if (!tpl) return;
    document.querySelectorAll('.ap-pricerow').forEach(function (row) {
      if (row.parentNode.querySelector(':scope > .bfx')) return;
      /* colour / option swatches sit right under the price, the Black Friday box follows them */
      var anchor = row, op = row.parentNode.querySelector(':scope > .ap-options');
      if (op) { row.parentNode.insertBefore(op, row.nextSibling); anchor = op; }
      var el = tpl.content.firstElementChild.cloneNode(true);
      row.parentNode.insertBefore(el, anchor.nextSibling);
      if (!bfx) bfx = el;
    });
    var j = tpl.content.querySelector('[data-bfx-ids]');
    if (j && !ids) { try { ids = {}; JSON.parse(j.textContent).forEach(function (i) { ids[i] = 1; }); } catch (e) { ids = {}; } }
    paintCart();
  }
  var cart = null;
  function fetchCart() {
    if (cartBusy) return; cartBusy = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { if (pending || Date.now() - lastAdd < 4000) return; cart = c; render(); }).catch(function () {}).then(function () { cartBusy = false; });
  }
  function paintCart() { if (bfx && bfx.getAttribute('data-bfx') !== 'general') fetchCart(); }
  function render() {
    if (!bfx || !cart) return;
    var mode = bfx.getAttribute('data-bfx'); if (mode === 'general') return;
    var pid = +bfx.getAttribute('data-pid'), price = +bfx.getAttribute('data-price');
    document.querySelectorAll('.bfx').forEach(function (box) {
      var msg = box.querySelector('[data-bfx-msg]');
      if (mode === 'games') {
        var seen = {}, games = [], inBag = false;
        (cart.items || []).forEach(function (it) { if (ids && ids[it.product_id] && it.final_line_price > 0 && !seen[it.product_id]) { seen[it.product_id] = 1; games.push(it); if (it.product_id === pid) inBag = true; } });
        var n = games.length;
        box.querySelectorAll('[data-bfx-slot]').forEach(function (s, k) {
          var it = games[k], on = !!it, img = s.querySelector('img');
          s.classList.toggle('is-on', on);
          if (on && it.image) { if (!img) { img = document.createElement('img'); img.alt = ''; s.appendChild(img); } if (img.getAttribute('src') !== it.image) img.src = it.image; s.title = it.product_title || ''; }
          else if (img) { img.remove(); s.title = ''; }
        });
        box.classList.toggle('is-done', n >= 3);
        if (n >= 3) msg.innerHTML = '<b>3 games in your bag.</b> Your 2 gifts are free.';
        else if (inBag) msg.innerHTML = '<b>' + n + ' of 3</b> games in your bag. Add ' + (3 - n) + ' more different game' + (3 - n > 1 ? 's' : '') + ' to get 2 gifts free.';
        else if (n === 2) msg.innerHTML = 'You have 2 games in your bag. <b>Add one more</b> and both gifts are free.';
        else msg.innerHTML = (n ? 'You have ' + n + ' game in your bag. ' : '') + '<b>Add ' + (3 - n) + ' games</b> to get both gifts free.';
      } else if (mode === 'beauty') {
        var goal = +box.getAttribute('data-goal') || 4000, sum = 0, inBag2 = false;
        (cart.items || []).forEach(function (it) { if (ids && ids[it.product_id] && it.final_line_price > 0) { sum += it.final_line_price; if (it.product_id === pid) inBag2 = true; } });
        var shown = inBag2 ? sum : sum + price;
        var fill = box.querySelector('[data-bfx-fill]'); if (fill) fill.style.transform = 'scaleX(' + Math.min(1, shown / goal) + ')';
        box.classList.toggle('is-done', sum >= goal);
        if (sum >= goal) msg.innerHTML = '<b>Both gifts unlocked.</b> They are added free at checkout.';
        else if (inBag2) msg.innerHTML = '<b>' + money(sum) + ' of ' + money(goal) + '</b> in beauty. Add ' + money(goal - sum) + ' more to get both gifts free.';
        else if (shown >= goal) msg.innerHTML = '<b>Add this</b> and both gifts are yours, free.';
        else msg.innerHTML = '<b>Add this</b> to reach ' + money(shown) + ' of ' + money(goal) + '. Then ' + money(goal - shown) + ' more for both gifts.';
      }
    });
  }
  /* Black Friday card "+": instant. The slot fills straight away from a local copy of the bag, then one
     /cart/update.js call (not cart/add, so the drawer app stays closed) saves it and returns the real bag. */
  var queue = Promise.resolve(), pending = 0, lastAdd = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bfx-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var vid = String(b.getAttribute('data-bfx-add')), pr = +b.getAttribute('data-price') || 1;
    if (!cart) cart = { items: [] };
    var line = null; (cart.items || []).forEach(function (it) { if (String(it.variant_id) === vid) line = it; });
    if (line) { line.quantity++; line.final_line_price += pr; }
    else { line = { variant_id: +vid, product_id: +b.getAttribute('data-pid'), quantity: 1, final_line_price: pr, image: b.getAttribute('data-img') }; cart.items.push(line); }
    render();
    b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1400);
    var qty = line.quantity; pending++; lastAdd = Date.now();
    queue = queue.then(function () {
      var up = {}; up[vid] = qty;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: up, sections: 'cart-icon-bubble' }) })
        .then(function (r) { return r.json(); }).then(function (res) {
          var html = res && res.sections && res.sections['cart-icon-bubble'], el = document.getElementById('cart-icon-bubble');
          if (html && el) { var d = new DOMParser().parseFromString(html, 'text/html'); var inner = d.querySelector('.shopify-section'); el.innerHTML = inner ? inner.innerHTML : html; }
          if (res && res.items && pending === 1) { cart = res; render(); }
        }).catch(function () {}).then(function () { pending--; lastAdd = Date.now(); });
    });
  }, true);
  ['afkar:cart:updated', 'cart:updated', 'cart:refresh', 'opus:cart:updated'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(paintCart, 300); }); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-ap-add],[name="add"],.ap-sticky button,[data-afx-add]')) setTimeout(paintCart, 1500); });
  setInterval(function () { if (!document.hidden) paintCart(); }, 8000);
  /* product page: Add to bag first, Pair it with right after it */
  function swapPairs() {
    document.querySelectorAll('.ap-info').forEach(function (info) {
      var pairs = info.querySelector(':scope > .ap-pairs'), cta = info.querySelector(':scope > .ap-cta');
      if (!pairs || !cta || pairs.__bfMoved) return;
      var after = cta.nextElementSibling && cta.nextElementSibling.classList.contains('ap-msg') ? cta.nextElementSibling : cta;
      after.parentNode.insertBefore(pairs, after.nextSibling); pairs.__bfMoved = true;
    });
  }
  /* games rail: arrows + desktop drag */
  function railState(t) {
    var wrap = t.closest('.bfx-rail__wrap'), rail = t.closest('.bfx-rail'); if (!wrap || !rail) return;
    var end = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4, start = t.scrollLeft <= 4;
    wrap.classList.toggle('is-end', end);
    rail.querySelectorAll('[data-bfx-prev]').forEach(function (b) { b.disabled = start; });
    rail.querySelectorAll('.bfx-arrow[data-bfx-next]').forEach(function (b) { b.disabled = end; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bfx-prev],[data-bfx-next]'); if (!b) return;
    var rail = b.closest('.bfx-rail'), t = rail && rail.querySelector('[data-bfx-track]'); if (!t) return;
    e.preventDefault();
    var card = t.querySelector('.bfx-card'), step = card ? (card.offsetWidth + 10) * 2 : 280;
    t.scrollBy({ left: b.hasAttribute('data-bfx-prev') ? -step : step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) { if (e.target && e.target.matches && e.target.matches('[data-bfx-track]')) railState(e.target); }, true);
  function railInit() { document.querySelectorAll('[data-bfx-track]').forEach(function (t) { if (t.__rail) return; t.__rail = 1; railState(t);
    var down = false, sx = 0, sl = 0, moved = false;
    t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.target.closest('button')) return; down = true; moved = false; sx = e.clientX; sl = t.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; t.classList.add('is-drag'); } if (moved) t.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { t.classList.remove('is-drag'); }, 0); });
  }); }
  pdpNote(); swapPairs(); railInit();
  document.addEventListener('DOMContentLoaded', railInit);
  document.addEventListener('DOMContentLoaded', function () { pdpNote(); swapPairs(); });
  tick(); setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
  document.addEventListener('shopify:section:load', tick);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bf-copy]'); if (!b) return;
    e.preventDefault();
    var code = b.getAttribute('data-bf-copy'), label = b.querySelector('[data-bf-copy-label]') || b, old = label.textContent;
    function done() { label.textContent = 'Copied'; b.classList.add('is-copied'); setTimeout(function () { label.textContent = old; b.classList.remove('is-copied'); }, 1600); }
    try { navigator.clipboard.writeText(code).then(done, done); } catch (err) { done(); }
  });
})();
